import { FILTERS } from '@/constants/filters.js';
import { toUuid, toVfId, isVfId } from 'commons/util/parse.js';

export const translateFilters = (filters) => filters.map((filter) => {
    // Sigh add a special condition here for actor uuid and moderator uuid to convert it to a uuid
    if (filter.field === FILTERS.actor_uuid.field || filter.field === FILTERS.moderator_uuid.field || filter.field === FILTERS.moderator_actions.field) {
        return {
            ...filter,
            values: filter.values.map(translateIdToUuid),
        };
    }
    return filter;
});

export const translateIdToUuid = (id) => {
    try {
        // If its not a number, then lets just return the id itself
        if (isNaN(id)) {
            return id;
        }
        id = parseInt(id, 10);
        // only translate the id to a uuid if its a valid vf id
        return isVfId(id) ? toUuid(id) : id;
    }
    // on any failure (like toUuid parsing fail), lets just return what the user inputted
    catch (e) {
        return id;
    }
};

export const translateUuidToId = (value) => {
    try {
        return toVfId(value);
    }
    // on any failure ( like toVfId parsing fail), lets just return what the user inputted
    catch (e) {
        return value;
    }
};
